export { default } from './Fade';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Fade/index.js
// module id = 403
// module chunks = 2